import styles from "./InteractiveBadge.module.scss";

const label = "Interactive presentation";

/**
 * Marks a post that holds an animation or 3D scene you can play with. Pure CSS, no state, cheap in a list.
 * `decorative` when the words beside it already say so (the blog's Interactive filter): no label, no tooltip.
 */
export default function InteractiveBadge({ decorative = false }: { decorative?: boolean }) {
  const named = decorative ? { "aria-hidden": true } : { "data-tip": label, role: "img", "aria-label": label };
  return (
    <span className={styles.badge} {...named}>
      <span className={styles.ring} />
      <span className={styles.core} />
    </span>
  );
}
